import { createStore } from 'vuex'

export default createStore({
	state:{
		user:{},
		token:false,
		navIndex:{
			// 行业资讯
			newsInformationIndex:1,
			// 关于我们
			aboutUs:0,
			// 基础服务菜单
			basicService:0
		}
	},
	getters:{
		
	},
	mutations:{
		// 初始化用户信息
		initUser(state){
			let user = window.sessionStorage.getItem('user')
			if(user){
				state.user = JSON.parse(user)
				state.token = state.user.token
			}
		},
		// 登录
		login(state,user){
			// 保存登录状态
			state.user = user
			state.token = user.token
			// 存储到本地存储
			window.sessionStorage.setItem('user',JSON.stringify(state.user))
			window.sessionStorage.setItem('token',state.token)
		},
		// 退出登录
		logout(state){
			// 清除状态
			state.user = {}
			state.token = false
			// 清除本地存储
			window.sessionStorage.clear()
		},
		// 修改关于我们导航Index
		activeAboutUsIndex(state,index){
			state.navIndex.aboutUs = index
			// 存储到本地存储
			window.sessionStorage.setItem('aboutUsIndex',JSON.stringify(state.navIndex.aboutUs))
		},
		// 修改基础服务Index
		activeBasicService(state,index){
			state.navIndex.basicService = index
			// 存储到本地存储
			window.sessionStorage.setItem('basicServiceIndex',JSON.stringify(state.navIndex.basicService))
		},
		// 修改行业资讯Index
		activeNewsInformationIndex(state,index){
			state.navIndex.newsInformationIndex = index
			// 存储到本地存储
			window.sessionStorage.setItem('newsInformationIndex',JSON.stringify(state.navIndex.newsInformationIndex))
		}
	},
	actions:{
		
	},
	modules: {
		  
	}
})
